<template>
  <div class="d-flex">
    <div
      v-for="(bet, field) in filteredBets"
      :key="field" class="field d-flex align-center"
    >
      <fai
        :icon="['fad', 'square-full']"
        :class="`field-icon-${field}`"
        class="field-icon mr-1"
      />
      {{ bet | toScrap }}
    </div>
  </div>
</template>


<script>
export default {
  props: {
    bets: {
      type: Object,
      required: true,
    },
  },
  computed: {
    filteredBets() {
      return Object
        .entries(this.bets)
        .reduce((acc, [k, v]) => {
          if (v) {
            acc[k] = v
          }
          return acc
        }, {})
    },
  },
}
</script>

<style lang="scss" scoped>
.field {
  margin-right: 12px;

  &:last-of-type {
    margin-right: 0;
  }
}

.field-icon {
  &-1 {
    color: yellow;
  }

  &-3 {
    color: #18a318;
  }

  &-5 {
    color: blue(600);
  }

  &-10 {
    color: #a307a3;
  }

  &-20 {
    color: orange;
  }

  g path.fa-secondary {
    fill: black;
    opacity: 0.8;
  }
}
</style>
